// extracted by mini-css-extract-plugin
export var block = "transition-module--block--22d2a";
export var container = "transition-module--container--78ad6";
export var flash = "transition-module--flash--1df02";
export var logo = "transition-module--logo--f0fef";